<template>
   <button
      v-if="action"
      :class="btnClasses"
      @mouseenter="hovered = true"
      @mouseleave="hovered = false"
      @click="emits('handleAction')"
      :disabled="disabled"
   >
      <slot></slot>
      <div :class="['action-text-wrapper']" v-if="text?.do">
         <span :class="['text', 'display']">{{ handleActionText }}</span>
         <!-- PLACEHOLDER SO THE BUTTON DONES CHANGE WIDGES -->
         <span :class="['text', 'placeholder']">{{ text.do }}</span>
         <span v-if="text.done" :class="['text', 'placeholder']">{{
            text.done
         }}</span>
         <span v-if="text.undo" :class="['text', 'placeholder']">{{
            text.undo
         }}</span>
      </div>
      <span v-else class="text">{{ text }}</span>
      <IconArrowRight class="fill" v-if="icon && icon === 'arrow-right'" />
      <IconCaretRight class="fill" v-if="icon && icon === 'caret'" />
   </button>
   <nuxt-link
      v-else
      :class="btnClasses"
      :to="btnLink"
      :target="btnTarget"
      :disabled="disabled"
   >
      <slot></slot>
      <span v-if="text">{{ text }}</span>
      <IconArrowRight class="fill" v-if="icon && icon === 'arrow-right'" />
      <IconCaretRight class="fill" v-if="icon && icon === 'caret'" />
   </nuxt-link>
</template>

<script setup lang="ts">
import IconArrowRight from "~/assets/images/icons/arrow-right-line.svg?component";
import IconCaretRight from "~/assets/images/icons/caret-right.svg?component";

const emits = defineEmits(["handleAction"]);
const props = defineProps({
   text: {
      type: [
         String,
         {
            do: { type: String, default: null, required: true },
            done: { type: String, default: null },
            undo: { type: String, default: null },
         },
      ],
      default: null,
   },
   url: { type: [String, Object], default: null },
   target: { type: Boolean, default: false },
   textLink: { type: Boolean, default: false },
   // button component props
   classes: { type: String, default: null },
   disabled: { type: Boolean, default: false },
   action: { type: Boolean, default: false },
   actionActive: { type: Boolean, default: false },
   buttonType: {
      type: [String, Array],
      default: "primary",
      validate: (value) =>
         ["primary", "secondary", "small", "success", "error"].includes(value),
   },
   icon: {
      type: [String, Boolean],
      default: false,
      validate: (value) =>
         typeof value == "string"
            ? ["arrow-right", "caret"].includes(value)
            : true,
   },
});

const hovered = ref(false);

// computed
const btnTarget = computed(() => (props.target ? "_blank" : "_self"));
const btnLink = computed(() => props.url);
const btnClasses = computed(() => [
   "button",
   props.classes,
   props.buttonType,
   props.text ? `` : `icon-only`,
   props.disabled ? `disabled` : ``,
   { icon: props.icon, "text-link": props.textLink },
]);
const handleActionText = computed(() => {
   return !props.actionActive
      ? props.text?.do
      : hovered.value
      ? props.text?.undo
      : props.text?.done;
});
</script>
<style lang="scss">
@import url("~/assets/scss/buttons.scss");
</style>
